.closeButton {
  cursor: pointer;
}
